export { Spacing as ButtonGroupSpacing } from '@doordash/design-language';
export { ButtonType as ButtonGroupButtonType } from '@doordash/component-button';

var ButtonGroupLayout;

(function (ButtonGroupLayout) {
  ButtonGroupLayout["Split"] = "LAYOUTS/SPLIT";
  ButtonGroupLayout["Fill"] = "LAYOUTS/FILL";
  ButtonGroupLayout["Stack"] = "LAYOUTS/STACK";
})(ButtonGroupLayout || (ButtonGroupLayout = {}));

var ButtonGroupAlignment;

(function (ButtonGroupAlignment) {
  ButtonGroupAlignment["Center"] = "center";
  ButtonGroupAlignment["FlexStart"] = "flex-start";
  ButtonGroupAlignment["FlexEnd"] = "flex-end";
  ButtonGroupAlignment["Baseline"] = "baseline";
  ButtonGroupAlignment["Stretch"] = "stretch";
})(ButtonGroupAlignment || (ButtonGroupAlignment = {}));

var ButtonGroupSlotType;

(function (ButtonGroupSlotType) {
  ButtonGroupSlotType["Primary"] = "SLOTTYPES/PRIMARY";
  ButtonGroupSlotType["Secondary"] = "SLOTTYPES/SECONDARY";
  ButtonGroupSlotType["Tertiary"] = "SLOTTYPES/TERTIARY";
})(ButtonGroupSlotType || (ButtonGroupSlotType = {}));

export { ButtonGroupAlignment, ButtonGroupLayout, ButtonGroupSlotType };
